import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TipoCartera } from "@p-p-portafolio/interfaces/tipoCartera";
import { EntityOperationResult } from "@shared/interfaces/responses/entity-operation-result";
import { environment } from "src/environments/environment";
import { PermissionsResponse } from "../../parametria/portafolio/interfaces/permissions";
import { AuthLogin } from "@pages/authentication/interfaces/AuthLogin";
import { DataUser } from "@pages/authentication/interfaces/DataUser";
import { Observable, of, switchMap, throwError } from "rxjs";
import { TokenModel, UpdateToken } from "@pages/authentication/interfaces/UpdateToken";
import { Router, RouterLink } from "@angular/router";
import { ValidateTokenResponse } from "@pages/authentication/interfaces/ValidateToken";
import { CryptDataService } from "@shared/utils/crypt-data.service";
import * as moment from "moment";

export interface IAuthRes {
    token: string;
    success: boolean;
}
@Injectable({
    providedIn: "root",
})
export class SecurityNewBackService {
    private baseUrl = environment.apiNewBackBaseUrl + "Seguridad/Authenticate";

    constructor(private http: HttpClient, private router: Router, private _cryptService: CryptDataService) {}

    validateTokenNewBack(): Observable<boolean> {
        const token = sessionStorage.getItem("TokenNewBack");
        if (token === null) {
            // this.router.navigateByUrl('/sesion-expirada');
            return of(false);
        } else {
            this.renewToken();
            return of(true);
        }
    }

    renewToken(): void {
        try {
            let tokenTime = this._cryptService.decryptDataSession(sessionStorage.getItem("TokenNBTime"));

            const dateLogin: Date = JSON.parse(sessionStorage.getItem("dateLogin"));

            let timeToExpiry = parseFloat(tokenTime) * 0.5;

            let dateNow = moment(new Date()).format("YYYY-MM-DD");

            let fecha = new Date(dateLogin);

            let fechaRestante = new Date().getTime() - fecha.getTime();

            fechaRestante = fechaRestante / 1000;
            // console.log(fechaRestante, 'fechaRestante')
            // console.log(timeToExpiry, 'timeToExpiry')
            if (fechaRestante >= timeToExpiry) {
                this.getNewBackendToken();
            }
        } catch (error) {
            console.log(error);
        }
    }

    getNewBackendToken() {
        const payload = {
            credentials:
                "We3QwQmlmjSnSZ9FNHVlGncenVDuAM/oYo81+KwVk8jGX17daTSex6kyZfFrie0wHEsqoIl692DoBuCeQM3bRWPLTlzRBoW+mhIaFRmwfjj75Es9uK8TV9K8twbVtk0omUCZ76/fUx7+C6qFkl4FPp9FcO0qGx1ug/Ueia2rU9kNLmNOtLLD5Su+C0EvqCqHbZN5j4vze+lDC7N6wRw3VstM/9ekc78k1KgeQHwtf18=",
        };

        const headers = new HttpHeaders().set("Content-Type", "application/json");

        return this.http.post<IAuthRes>(this.baseUrl, payload, { headers });
    }
}
